import { render, staticRenderFns } from "./CreateReservedAccount.vue?vue&type=template&id=3ce5f2c9&scoped=true"
import script from "./CreateReservedAccount.vue?vue&type=script&lang=ts"
export * from "./CreateReservedAccount.vue?vue&type=script&lang=ts"
import style0 from "./CreateReservedAccount.vue?vue&type=style&index=0&id=3ce5f2c9&prod&lang=scss&scoped=true"
import style1 from "./CreateReservedAccount.vue?vue&type=style&index=1&id=3ce5f2c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce5f2c9",
  null
  
)

export default component.exports